// mapping des icônes en ligne haute résolution
const FILE_ICONS = {
  pdf: "https://img.icons8.com/color/256/pdf.png",
  doc: "https://img.icons8.com/color/256/microsoft-word-2019.png",
  docx: "https://img.icons8.com/color/256/microsoft-word-2019.png",
  xls: "https://img.icons8.com/color/256/microsoft-excel-2019.png",
  xlsx: "https://img.icons8.com/color/256/microsoft-excel-2019.png",
  ppt: "https://img.icons8.com/color/256/microsoft-powerpoint-2019.png",
  pptx: "https://img.icons8.com/color/256/microsoft-powerpoint-2019.png",
  accdb: "https://img.icons8.com/color/256/microsoft-access-2019.png",
  mdb: "https://img.icons8.com/color/256/microsoft-access-2019.png",
  zip: "https://img.icons8.com/color/256/zip.png",
  rar: "https://img.icons8.com/color/256/zip.png",
  "7z": "https://img.icons8.com/color/256/zip.png",
  default: "https://img.icons8.com/color/256/document--v1.png"
};

/**
 * Retourne l'image ou l'icône correspondant au fichier
 * @param {string} filePath - Chemin ou URL du fichier
 * @returns {string} URL de l'image ou icône
 */
export const getFilePreview = (filePath) => {
  if (!filePath) return FILE_ICONS.default;

  const ext = filePath.split('.').pop().toLowerCase();

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];

  if (imageExtensions.includes(ext)) {
    return filePath; // image réelle
  }

  return FILE_ICONS[ext] || FILE_ICONS.default; // icône selon extension
};
